/** @format */

export const featureFlagNames = [
    'BEAK-2867-(model-recommendations)',
    'BOO-3170-(sell-balance)',
    'LOVE-747-(enhanced-product-protection)',
    'BEAK-3098-(auto-out-of-stock-search)',
    'BEAK-3676-(usp-tags)',
    'APE-2838-(self-serve-returns-phase-2)',
    'TUR-3230-(super-skus)',
    'LOVE-1153-(sell-journey-accessories-checklist)',
    'APE-3416-(buy-transaction-progress-tracker)',
    'TUR-3223-(semantic-search-endpoint)',
    'BOO-3485-(vat-registered-buy)',
    'IAM-7-(anonymous-user)',
    'LOVE-1461-(basket-MPBX-bridge)',
    'LOVE-1595-(basket-context-proxy)',
    'TUR-3496-(nl-search)',
    'BEAK-4191-(inventory-context-product-page-update)',
    'BOO-4415-(kit-journey)',
    'BOO-4415-(kit-journey-product-page)',
    'BOO-4415-(kit-intel)',
    'BOO-4415-(kit-intel-product-page)',
    'BEAK-4545-(AQA-chat)',
    'IAM-28-(idp-enabled)',
    'SWARM-2-(kit-value)',
    'APE-3584-(consolidate-intercom-workspaces)',
] as const;

export enum RecommendationsVariant {
    CONTROL = 'control',
    VARIANT = 'variant',
}

export const BASKET_BRIDGE_HEADER = 'X-Basket-Bridge' as const;

export enum BasketBridgeHeaderValue {
    ON = 'on',
    OFF = 'off',
}

export const ANONYMOUS_USER = 'IAM-7-(anonymous-user)' as const;

export const BASKET_MPBX_BRIDGE_FEATURE_FLAG =
    'LOVE-1461-(basket-MPBX-bridge)' as const;

export const BASKET_CONTEXT_PROXY_FEATURE_FLAG =
    'LOVE-1595-(basket-context-proxy)' as const;

export const IDP_ENABLED = 'IAM-28-(idp-enabled)' as const;
